import { useContext } from 'react';
import {
  Caption1,
  Input,
  Menu,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Subtitle1,
  ToolbarButton,
  makeStyles,
  tokens,
} from '@fluentui/react-components';
import { MoreHorizontalRegular, LinkRegular } from '@fluentui/react-icons';

import { ToastContext } from '@shared/contexts';

import { TChangeV2 } from '../../models';
import { getChangeReference } from '../../utils/automationRules';
import { StatusBadge } from '../shared/StatusBadge';

const useStyles = makeStyles({
  root: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: tokens.spacingHorizontalL },
  left: { display: 'flex', flexDirection: 'column', gap: tokens.spacingVerticalXXS, minWidth: 0, flex: 1 },
  muted: { color: tokens.colorNeutralForeground3 },
  right: { display: 'flex', alignItems: 'center', gap: tokens.spacingHorizontalS, flexShrink: 0 },
  titleInput: { maxWidth: '640px' },
});

type TProps = {
  change: TChangeV2;
  editable: boolean;
  onTitleChange: (title: string) => void;
};

export const ChangeHeader = ({ change, editable, onTitleChange }: TProps) => {
  const classes = useStyles();
  const { show } = useContext(ToastContext);

  return (
    <div className={classes.root}>
      <div className={classes.left}>
        <Caption1 className={classes.muted}>{getChangeReference(change)}</Caption1>
        {editable ? (
          <Input
            className={classes.titleInput}
            size="large"
            appearance="underline"
            value={change.title}
            placeholder="Change title"
            aria-label="Change title"
            onChange={(_, data) => onTitleChange(data.value)}
          />
        ) : (
          <Subtitle1>{change.title || 'Untitled change'}</Subtitle1>
        )}
      </div>
      <div className={classes.right}>
        <StatusBadge status={change.status} size="extra-large" />
        <Menu>
          <MenuTrigger disableButtonEnhancement>
            <ToolbarButton aria-label="More actions" icon={<MoreHorizontalRegular />} />
          </MenuTrigger>
          <MenuPopover>
            <MenuList>
              <MenuItem icon={<LinkRegular />} onClick={() => show('info', 'Link copied to the clipboard.')}>
                Copy link
              </MenuItem>
            </MenuList>
          </MenuPopover>
        </Menu>
      </div>
    </div>
  );
};
